import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import store from './store'
import VueLazyload from "vue-lazyload";
import VueAnalytics from "vue-analytics"

Vue.config.productionTip = false

const isProd = process.env.NODE_ENV === "production"

Vue.use(VueLazyload);
Vue.use(VueAnalytics, {
  id: 'UA-139332547-1',
  router,
  autoTracking: {
    pageviewOnLoad: false,
    exception: true,
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
